// ABOUTME: Rule telling whether the current user may ADD a favorite on a node of a given hierarchy,
// ABOUTME: driven by the favoriteRoles system setting. Mirrors the server rule in userFavorites/domain/favoriteRoles.ts.

import { HIERARCHIES_ADMIN_ROLES } from '@src/_new/modules/auth/canAccessHierarchies';

type RoleList = string[] | null | undefined;

export interface FavoriteRoles {
    configurableProducts?: RoleList;
    nonConfigurableProducts?: RoleList;
    productFamilies?: RoleList;
    default?: RoleList;
}

/** The catalog hierarchies of `prototype.hierarchies` the named keys stand for. */
export interface FavoriteCatalogHierarchies {
    prototype?: string | null;
    model?: string | null;
    modelSelection?: string | null;
}

const resolveRoleList = (
    favoriteRoles: FavoriteRoles,
    hierarchyId: string,
    catalogHierarchies: FavoriteCatalogHierarchies,
): RoleList => {
    if (hierarchyId === catalogHierarchies.prototype) return favoriteRoles.configurableProducts;
    if (hierarchyId === catalogHierarchies.model) return favoriteRoles.nonConfigurableProducts;
    if (hierarchyId === catalogHierarchies.modelSelection) return favoriteRoles.productFamilies;
    return favoriteRoles.default;
};

/**
 * Picks the role list of the part of the catalog the hierarchy is (`prototype.hierarchies`): the
 * prototype hierarchy is `configurableProducts`, the model hierarchy `nonConfigurableProducts`,
 * the model-selection hierarchy `productFamilies`; any other hierarchy reads `default`.
 * Absent or null list = every user; an empty list = admins only. PIM_ADMIN and PIM_SUPERADMIN
 * always pass. Removing a favorite is always allowed: the rule only gates adding one.
 */
export const canAddFavorite = (
    favoriteRoles: FavoriteRoles | null | undefined,
    hierarchyId: string,
    catalogHierarchies: FavoriteCatalogHierarchies | null | undefined,
    hasUserRole: (role: string) => boolean,
): boolean => {
    if (!favoriteRoles || !hierarchyId) return true;
    const allowedRoles = resolveRoleList(favoriteRoles, hierarchyId, catalogHierarchies ?? {});
    if (allowedRoles == null) return true;
    if (HIERARCHIES_ADMIN_ROLES.some(role => hasUserRole(role))) return true;
    return allowedRoles.some(role => hasUserRole(role));
};
